import { styled, TextField } from '@mui/material';

import type { StyledTextFieldProps } from './types';

export const StyledTextField = styled(TextField, {
  shouldForwardProp: prop => prop !== 'disableGutters',
})<StyledTextFieldProps>(({ disableGutters }) => ({
  ...(disableGutters && {
    '& .MuiOutlinedInput-root': {
      paddingLeft: 0,
      paddingRight: 0,
      fieldset: {
        borderColor: 'transparent',
      },
      '&:hover fieldset': {
        borderColor: 'transparent',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'transparent',
      },
    },
  }),
}));
